import React from "react"
import moment from "moment"
import {Link} from "react-router-dom"
import {useTranslation} from "react-i18next"

const ListItemOrderHistory = ({id, user, ordered_at}) => {
  const {t} = useTranslation()
  return (
    <div className="sh-list-item">
      <div className="content">
        <Link to={`/order_history/${id}`}>
          <div className="primary">{t("shoppingCart.orderId", {id: id})}</div>
          <div className="secondary simplified">
            <span>
              {t("shoppingCart.orderedByAt", {
                email: user.email,
                orderedAt: moment(ordered_at).format("DD.MM.YYYY")
              })}
            </span>
          </div>
        </Link>
      </div>
    </div>
  )
}

export default ListItemOrderHistory



// WEBPACK FOOTER //
// ./src/components/list_items/ListItemOrderHistory.js